import { _, Backbone, moment, Radio, Foundation } from "../../../vendor";
import { Backform, Biscuit } from "../../utils";
import InboomaBaseView from "../InboomaBaseView";
import { getApiHost } from "../../Sync";
import { generateClientHash } from "../../utils/Uri";
import * as FileSaver from "../../../vendor/FileSaver";

import GetGroupListTpl from "../../templates/orders/GetGroupListTpl.html";

export default InboomaBaseView.extend({
  el: "#get-group-list-form",
  template: GetGroupListTpl,

  ui: {
    formErrorDiv: ".off-canvas__form-error",
  },

  initialize() {
    this.render();
  },

  onRender() {
    const that = this,
      formErrorDiv = this.getUI("formErrorDiv");

    const model = new Backbone.Model({
      begin: new Date(),
      end: new Date(),
    });

    const fields = [
      {
        name: "begin",
        label: this.t("begin", null, "capital"),
        control: "datepicker",
        size: {
          large: "4",
        },
      },
      {
        name: "end",
        label: this.t("end", null, "capital"),
        control: "datepicker",
        size: {
          large: "4",
        },
      },
      {
        label: this.t("generate", null, "capital"),
        control: "button",
        extraClasses: ["button-submit"],
      },
    ];

    const form = new Backform.Form({
      el: that.$el.find("form"),
      model,
      fields,
      events: {
        "click .button-submit"(ev) {
          ev.preventDefault();

          formErrorDiv.addClass("hide");

          const begin = moment(model.get("begin")),
            end = moment(model.get("end"));

          if (!begin.isValid() || !end.isValid()) {
            // @todo Communicate errors more cleary
            formErrorDiv.html(that.t("invalid_time_format")).removeClass("hide");
            return;
          }
          const xmlHttp = new XMLHttpRequest();

          xmlHttp.open(
            "GET",
            getApiHost() +
              "/forms/group_list/" +
              begin.format("YYYY-MM-DD") +
              "/" +
              end.format("YYYY-MM-DD"),
            true,
          );

          xmlHttp.setRequestHeader("Authorization", "Bearer " + Biscuit.get("token"));
          xmlHttp.responseType = "blob";

          xmlHttp.onload = function () {
            const blob = new Blob([xmlHttp.response], { type: "aapplication/vnd.ms-excel" });
            FileSaver.saveAs(
              blob,
              that.t("list deliveries") +
                " " +
                begin.format("DD.MM.YYYY") +
                " - " +
                end.format("DD.MM.YYYY") +
                ".xlsx",
            );
          };

          xmlHttp.send(null);
          // window.location=getApiHost() + '/forms/group_list/' + begin.format('YYYY-MM-DD') + "/" +  end.format('YYYY-MM-DD');
        },
      },
    }).render();

    this.modal = new Foundation.Reveal(this.$el);

    this.modal.open();

    this.$el.on("closed.zf.reveal", () => {
      Radio.channel("app").trigger("destroy:backform"); // Remove pikaday from DOM

      that.$el.foundation("_destroy");

      that.unbind();
      that.undelegateEvents();
      that.unbindEvents();
      that.unbindUIElements();

      Backbone.history.navigate("orders", { trigger: true });
      that.$el.off("closed.zf.reveal");
    });
  },
});
